const API_BASE_URL = process.env.BASE_URL

export const CLIENTS = {
    CREATE_PORTAL_SESSION: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/create-portal-session/",
    LIST_PAYMENT_METHODS: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/payment-methods/",
    SAVE_PAYMENT_METHOD: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/save-payment-method/",
}
